import apiClient from "../../../../shared/infrastructure/api/client";

import { Therapist } from "../../domain/Therapist";

export interface AgreementStats {
  total: number;
  completed: number;
  in_progress: number;
  pending: number;
  skipped: number;
}

export interface PatientAgreementStats {
  patient_id: string;
  patient_name: string;
  total: number;
  completed: number;
  in_progress: number;
}

export interface HomeStats {
  pending_sessions: number;
  pending_notes: number;
  agreements: AgreementStats;
  agreements_by_patient: PatientAgreementStats[];
}

export const TherapistAPI = {
  getMe: () => apiClient.get<Therapist>("/therapists/me"),
  get: (id: string) => apiClient.get<Therapist>(`/therapists/${id}`),
  update: (id: string, data: Partial<Therapist>) => apiClient.patch<Therapist>(`/therapists/${id}`, data),
  delete: (id: string) => apiClient.delete(`/therapists/${id}`),
  getHomeStats: (id: string) => apiClient.get<HomeStats>(`/therapists/${id}/home-stats`),
};
